import $ from 'jquery'

export default {

  enable () {
    $('.block-conseils').each((index, elem) => {
      $(elem).find('.conseil-item').each((index, item) => {
        let button = $(item).find('.plus')
        let detail = $(item).find('.details')
     
        $(button).click((e) => {
          if($(item).hasClass('open')) {
            $(item).removeClass('open')
            $(button).removeClass('icon-minus-circle')
            $(button).addClass('icon-plus-circle')
          } else {
            $(item).addClass('open')
            $(button).addClass('icon-minus-circle')
            $(button).removeClass('icon-plus-circle')
          }
        })
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/blocks/block-conseils.js